import { PerformanceEmployeePerformanceInsightsSummaryFilter } from 'generated/resources/datatable.graphql'

import type { Filter } from 'modules/core/components/DataTable/types'

import type { GroupByType } from 'modules/performance_analytics/components/helpers'

import { getFilterPathForGroupBy } from './chartUtils'

const hasInProperty = (obj: unknown): obj is { in?: unknown[] } => {
  return Boolean(obj && typeof obj === 'object' && 'in' in obj)
}

/**
 * Finds the target filter for a given groupBy
 */
export const findTargetFilter = (
  groupBy: GroupByType,
  availableFilters: Filter<PerformanceEmployeePerformanceInsightsSummaryFilter>[],
  enabledFilters: Filter<PerformanceEmployeePerformanceInsightsSummaryFilter>[]
): Filter<PerformanceEmployeePerformanceInsightsSummaryFilter> | undefined => {
  const resolvedGroupBy = getFilterPathForGroupBy(groupBy)

  return (
    availableFilters.find((filter) => filter.filter.path === resolvedGroupBy) ||
    enabledFilters.find((filter) => filter.filter.path === resolvedGroupBy)
  )
}

/**
 * Checks if a filter is already enabled
 */
export const isFilterEnabled = (
  groupBy: GroupByType,
  enabledFilters: Filter<PerformanceEmployeePerformanceInsightsSummaryFilter>[]
): boolean => {
  const resolvedGroupBy = getFilterPathForGroupBy(groupBy)
  return enabledFilters.some((filter) => filter.filter.path === resolvedGroupBy)
}

/**
 * Gets current filter values for a groupBy
 */
export const getCurrentFilterValues = (
  groupBy: GroupByType,
  dataTableFilters: Record<string, unknown>
): unknown[] => {
  const resolvedGroupBy = getFilterPathForGroupBy(groupBy)
  const currentFilter = dataTableFilters[resolvedGroupBy]
  return hasInProperty(currentFilter) ? currentFilter.in || [] : []
}

/**
 * Creates a new filter with updated values
 */
export const createUpdatedFilter = (
  targetFilter: Filter<PerformanceEmployeePerformanceInsightsSummaryFilter>,
  newValues: unknown[]
): Filter<PerformanceEmployeePerformanceInsightsSummaryFilter> => {
  return { ...targetFilter, value: newValues }
}
